/*
 * username/password stay short dev credentials; `login` is the
 * Hostsharing-style login id (pac prefix + given/family name) issued
 * as preferred_username in the token.
 */
export const simulatedUsers = [
  {
    /* fixed UUIDs so the subject stays stable across logins, like a real IdP */
    uuid: '0720a533-d628-4bb1-8408-8d61f991a0ca',
    username: 'admin',
    password: 'admin',
    login: 'xyz-oliverbennett',
    name: 'Oliver Bennett',
    email: 'oliver.bennett@example.test',
  },
  {
    uuid: 'aa155d30-84a1-4015-b071-bf84f8e96a06',
    username: 'user',
    password: 'user',
    login: 'xyz-emmamiller',
    name: 'Emma Miller',
    email: 'emma.miller@example.test',
  },
];
